import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/cours-agenda`;
const token = localStorage.getItem("token");

/// GET
// Récupérer tous les cours de l’agenda
export const getAllCoursAgenda = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200)
      throw new Error("Échec de chargement des cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des cours agenda :", error);
    return [];
  }
};

// Récupérer un cours par ID
export const getCoursAgendaById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/byId/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200)
      throw new Error("Échec de chargement du cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du cours :", error);
    return {};
  }
};

/// POST
// Ajouter un cours
export const addCoursAgenda = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/add`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 201) throw new Error("Échec de l'ajout du cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du cours agenda :", error);
    throw error;
  }
};

// Duplication d'un cours
export const duplicateCoursAgenda = async (id) => {
  try {
    const response = await axios.post(`${apiUrl}/duplicate/${id}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 201)
      throw new Error("Échec de la duplication du cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la duplication du cours :", error);
    throw error;
  }
};

/// PUT
// Modifier un cours
export const updateCoursAgenda = async (id, data) => {
  try {
    const response = await axios.put(`${apiUrl}/update/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200)
      throw new Error("Échec de la modification du cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du cours :", error);
    throw error;
  }
};

/// DELETE
// Supprimer un cours
export const deleteCoursAgenda = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200)
      throw new Error("Échec de la suppression du cours");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du cours :", error);
    throw error;
  }
};
